<template>
  <div>
    <div class="gamebox">
      <div class="top">
        <div class="gametitle">
          {{ $t(`lang.str_detail`) }}
        </div>
      </div>
      <!-- 公共牌 -->
      <div class="public">
        <div class="title">{{ $t(`lang.str_common_poker`) }}</div>
        <div class="menu">
          <div class="item" v-for="(item,index) in common_poker" :key="index">
            <img alt=""
                 :src="require('../../assets/card/card'+'_'+parseInt(item / 100)+'_'+(item % 100)+'.png')">
          </div>
        </div>
      </div>
      <!-- 莊家 -->
      <div class="public ">
        <div class="title">{{ $t(`lang.str_banker_poker`) }}</div>
        <div class="menu">
          <div class="item" v-for="(item,index) in banker_poker" :key="index">
            <img alt=""
                 :src="require('../../assets/card/card'+'_'+parseInt(item / 100)+'_'+(item % 100)+'.png')">
          </div>
          <div class="bankerPokerType" style="margin-left:20px;">
            {{bankerPokerType}}
          </div>
        </div>
      </div>
      <!-- 玩家 -->
      <div class="public ">
        <div class="title"> {{ $t(`lang.str_hander_poker`) }}</div>
        <div class="menu">
          <div class="item" v-for="(item,index) in hand_poker" :key="index">
            <img alt=""
                 :src="require('../../assets/card/card'+'_'+parseInt(item / 100)+'_'+(item % 100)+'.png')">
          </div>
          <div class="handPokerType" style="margin-left:20px;">
            {{handlerPokerType}}
          </div>
          <div class="wintype">
            {{isWinType}}
          </div>
        </div>
      </div>
      <div class="top">
        <div class="gametitle">
          {{ $t(`lang.str_betDetail`) }}
        </div>
      </div>
      <div class="jokerbet">
        <div :style="{ 'width': Phone?`62.8vm`:`400px` }">
          <div class="detail">
            <div class="item">{{ $t(`lang.str_ante`) }}</div>
            <div class="item">{{ $t(`lang.str_flop`) }}</div>
            <div class="item">{{ $t(`lang.str_turn`) }}</div>
            <div class="item">{{ $t(`lang.str_river`) }}</div>
          </div>
          <div class="detail">
            <div class="item">{{Antes}}</div>
            <div class="item">{{flop}}</div>
            <div class="item">{{turn}}</div>
            <div class="item">{{river}}</div>
          </div>
          <div class="detail">
            <div class="item" style="color:#ed9108" v-if="jokerWin>0">+{{jokerWin}}</div>
            <div class="item" style="color:#ed9108" v-else>{{jokerWin}}</div>

          </div>
        </div>
        <div :style="{ 'width': Phone?`100px`:`60px` }">
          <div class="detail">
            <div class="item">{{ $t(`lang.str_joker_bonus`) }}</div>
          </div>
          <div class="detail">
            <div class="item">{{BonusBet}}</div>
          </div>
          <div class="detail" style="color:#0478f1">
            {{BonusWin}}
          </div>
        </div>
      </div>
    </div>
    <DescribeLayout
      :winValueTip="winValueTip"
      :winValueTotal="winValueTotal"
      :isTotalWin="isTotalWin"
      :describe_title = "describe_title"
      :describe_content="describe_content"
      :describe_message="describe_message"></DescribeLayout>
  </div>
</template>
<script>
import DescribeLayout from "../common/describe_layout.vue";

export default {
  name: "Game2000",
  components: {DescribeLayout},
  props:{
    winValueTip:null,
    winValueTotal:null,
    isTotalWin:false,
    describe_title:null,
    describe_content:null,
    describe_message:null,
    common_poker:[],
    banker_poker:[],
    hand_poker:[],
    jokerWin:0,
    handlerPokerType:0,
    bankerPokerType:0,
    isWinType:0,
    Antes:0,
    flop:0,
    turn:0,
    river:0,
    BonusBet:0,
    BonusWin:0,
    lang: '',
    Phone:false,
  },
  data()
  {
    return {

    }
  },
  methods: {

  }
}
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/joker/game_2000.vue